module.exports = __webpack_public_path__ + "static/media/img2-1.2d245282.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/nutricheck_foliar/CA/img2-1.png
// module id = 1765
// module chunks = 3